import { useHeaderStore } from '../../stores/header-store';

export default async function fetchInitialHeader() {
    const { fetchHeader } = useHeaderStore();
    await fetchHeader();
}
